import { Layout, Table, Pagination, Button, message, Input, Select } from "antd";
import { DeleteOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import axios from "axios";

const { Option } = Select;

const PdfListPage = () => {
  const { Content } = Layout;
  const accessToken = localStorage.getItem("accessToken") || null;
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    total: 0,
    current: 1,
    pageSize: 10,
  });
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetchData(pagination.current, pagination.pageSize, search);
  }, [pagination.current, pagination.pageSize, search]);

  const fetchData = async (page, pageSize, search) => {
    try {
      const response = await axios.post(
        "https://app.freezedriedsweets.co.uk/privateapp/public/index.php/api/auth/pdf_documents",
        { page, perPage: pageSize, search },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      setData(response.data.data);
      setPagination({
        total: response.data.pagination.total,
        current: response.data.pagination.current_page,
        pageSize: response.data.pagination.per_page,
      });
    } catch (error) {
      message.error("Failed to fetch PDF documents");
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(
        `https://app.freezedriedsweets.co.uk/privateapp/public/index.php/api/auth/pdf_documents/${id}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      message.success("PDF document deleted successfully");
      fetchData(pagination.current, pagination.pageSize, search); // Refresh the data
    } catch (error) {
      message.error("Failed to delete PDF document");
    }
  };

  const columns = [
    {
      title: 'PDF Name',
      dataIndex: 'pdfname',
      key: 'pdfname',
      // Apply styles for clean design
      render: (text) => <span >{text}</span>,
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <Button
          onClick={() => handleDelete(record.id)}
          type="danger"
          icon={<DeleteOutlined />}
          style={{ backgroundColor: '#f5222d', border: 'none', color: '#fff' }}
        >
          
        </Button>
      ),
    },
  ];

  return (
    <Layout>
      <Content style={{ padding: '24px', minHeight: 280, background: '#fff' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '16px' }}>Pdf List</h2>
        <Input
          placeholder="Search PDF Name"
          style={{ marginBottom: 16, width: '50%', padding: '10px', borderRadius: '8px', border: '1px solid #d9d9d9' }}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <Select
          defaultValue={pagination.pageSize}
          style={{ width: 120, marginLeft: 385 }}

          onChange={(value) => setPagination({ ...pagination, pageSize: value, current: 1 })}
        >
          <Option value={10}>10</Option>
          <Option value={25}>25</Option>
          <Option value={50}>50</Option>
          <Option value={100}>100</Option>

        </Select>
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          rowKey="id"
          style={{ marginBottom: 16 }}
        />
        <Pagination
          current={pagination.current}
          pageSize={pagination.pageSize}
          total={pagination.total}
          onChange={(page) => setPagination({ ...pagination, current: page })}
          style={{ marginTop: 16 }}
        />
      </Content>
    </Layout>
  );
};

export default PdfListPage;
